module.exports = __webpack_public_path__ + "static/apple-wallet-c658b4496e170fab3d2aa7ba5dd23995.png";